// removed by extract-text-webpack-plugin
module.exports = {"loadingContainer":"loadingContainer__3DJPb","loading":"loading__1cfBZ","dualRingLoader":"dualRingLoader__1AsXI"};


//////////////////
// WEBPACK FOOTER
// ./components/loader/style.css
// module id = 1TXn
// module chunks = 1